<template>
    <div class="container-fluid position-relative bg-BAT">
        <loading v-if="loading !== 0"></loading>
        <div>
            <div class="row">
                <div class="col-12 col-md-12 col-lg-12 col-xl-12" :class="{'mb-2': !client.active}">
                    <div class="shadow-lg fixed-top p-2 m-2 text-bat rounded-4 disclaimer-staff-details" v-if="!client.active">
                        <div class="row d-flex align-items-center justify-content-center">
                            <div class="col-2 d-flex align-items-center justify-content-center">
                                <img src="/img-version2/icons/staff/user_inactive.svg" alt="">
                            </div>
                            <div class="col-10">
                                <p class="fw-bold mb-0 text-break fs-7">Usuario inactivo: no acumula puntos ni aporta a la meta. Desvinculalo para tener un cupo disponible en el staff.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="container watch-container py-4" :class="{'mt-5': !client.active}">
                <div>
                    <div class="breadcrumbs-retos d-flex flex-column pb-2">
                        <div>
                            <a href="/home-bat">
                                <img src="/img/icons/homeBread.svg" alt="" />
                                Home
                            </a>
                            <a id="practica" class="link cursor-pointer link-active-bread"
                               :href="`/get-pdv-details/${this.pdv.id}`">Staff</a>
                            <span id="optionP" class="d-none color-active-miga"></span>
                        </div>
                    </div>
                    <a class="pb-2 pt-2" :href="`/get-pdv-details/${this.pdv.id}`"><img src="/img/icons/regresar.svg" alt="icon"></a>
                </div>
            </div>
            <div class="container mt-3">

                <div class="row d-flex align-items-center">
                    <div class="col-12 col-md-12">
                        <div class="d-flex justify-content-between align-items-center">

                            <h5 class="text-title-bat mb-0"><img v-if="client.is_champion" src="/img-version2/icons/staff/fluent-emoji-flat_rocket.svg" alt="Icono">  {{ formatName(client.user.name) }}</h5>
                            <div class="box-points-staff" :class="{'points-inactive': !client.active}">
                                <span class="text-center"><strong>{{ client.points }}<span> Puntos</span></strong></span>
                            </div>
                        </div>
                        <p class="fs-6">{{ formatName(pdv.name_pdv) }} - {{ pdv.insitu_code }}</p>
                    </div>

                    <!-- <div class="col-12 col-md-6 justify-content-end">
                            <button
                                class="btn rounded-3 bg-transparent p-2 px-3 my-3 text-bat align-items-center btn-popups text-indigo fw-bold d-block d-md-inline-block"
                                style="width:342px;">Inactivar usuario</button>
                    </div> -->

                </div>
                <div class="row d-flex align-items-center">
<!--                    <div class="col-12 col-md-12 my-1">-->
<!--                        <h5 class="text-title-bat">Progreso de actividades</h5>-->
<!--                        <div class="mt-1">-->
<!--                            <h6 class="text-bat" :class="{'color-text-staff-inactive': !client.active}">Basado en interacciones completadas.</h6>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                    <div class="col-12 col-md-6 my-2">-->
<!--                        <div class="demo-progress" >-->
<!--                            <el-progress :percentage="percentage" :text-color="'#fff'" :color="customColorMethods(percentage, client.active)" :text-inside="true" :stroke-width="20"></el-progress>-->
<!--                        </div>-->
<!--                        <div class="mt-1">-->
<!--                            <h6 class="text-bat" :class="{'color-text-staff-inactive': !client.active}">Lleva {{this.finishedActivities}} de {{this.totalActivities}} Actividades completadas</h6>-->
<!--                        </div>-->
<!--                    </div>-->
                    <div class="col-12 col-md-12" v-if="clientDisengagement">
                        <el-alert
                            type="warning"
                            :closable="false"
                            class="custom-alert-staff"
                            show-icon
                            v-if="admin_staff.indexOf(client_segment) >= 0"
                        >
                            <div class="text-bat">
                                La desvinculación será efectiva
                                <strong> próximamente.</strong>
                            </div>
                        </el-alert>
                    </div>
                    <div v-if="!clientDisengagement" class="col-12 col-md-12">
                        <el-alert
                            type="warning"
                            :closable="false"
                            class="custom-alert-staff"
                            show-icon
                            v-if="admin_staff.indexOf(client_segment) >= 0"
                        >
                            <div class="text-bat">
                                <strong>Importante:</strong>
                                Si el usuario es desvinculado del punto de venta,
                                <strong> perderá todos sus puntos acumulados.</strong>
                                Estos no se pueden transferir a otro usuario.
                            </div>
                        </el-alert>
                    </div>
                    <div v-if="!clientDisengagement" class="col-12 col-md-12">
                        <div v-if="admin_staff.indexOf(client_segment) >= 0" class="my-2">
                            <el-checkbox v-model="check_save"
                                         class=" custom-checkbox-staff d-flex align-items-center gap-2">
                       <span class="text-bat checkbox-text-staff">
                          Entiendo que al desvincular a este usuario,
                          <strong>Perderá todos sus puntos.</strong>
                       </span>
                            </el-checkbox>
                        </div>
                    </div>
                    <div v-if="!clientDisengagement" class="col-12 col-md-12">
                        <button v-if="admin_staff.indexOf(client_segment) >= 0" :disabled="!check_save"
                                class="btn rounded-3 bg-transparent p-2 px-3 my-3 text-bat align-items-center btn-popups text-indigo fw-bold d-block d-md-inline-block btn-staff"
                                @click="openInactivateModal(pdv_id)">
                            Desvincular usuario <img src="/img-version2/icons/staff/user-remove-blue.svg" alt="Icono">
                        </button>
                    </div>
                    <div v-if="!clientDisengagement" class="col-12 col-md-12">
                        <button v-if="admin_staff.indexOf(client_segment) >= 0"
                                class="btn rounded-3 bg-transparent p-2 px-3 my-3 text-bat align-items-center btn-popups text-indigo fw-bold d-block d-md-inline-block btn-staff"
                                @click="transferUser">
                            Transferir usuario <img src="/img-version2/icons/staff/arrow-swap-horizontal.svg" alt="Icono">
                        </button>
                    </div>

                </div>
                <!-- Modal Guia de Unidades -->
                <div class="modal fade" id="guiaDeUnidadesModal" tabindex="-1" aria-labelledby="guiaDeUnidadesModalLabel" aria-hidden="true">
                    <div class="modal-dialog modal-sm">
                        <div class="modal-content">
                            <div class="modal-header border-0">
                                <h1 class="modal-title fs-5" id="guiaDeUnidadesModalLabel">{{ unit_guide.title }}</h1>
                                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
                                </button>
                            </div>
                            <div class="modal-body border-0 d-flex justify-content-center">
                                <img class="img-fluid" :src="unit_guide.image" alt="guia-unidades">
                            </div>
                        </div>
                    </div>
                </div>
                <!-- tabs -->
                <div class="row content-profile-staff mt-2" id="my-objectives">
                    <div class="col-sm-12 col-md-6 order-1 order-md-1">
                        <div class="tabs order-2 order-md-1">
                            <ul class="nav nav-pills d-flex justify-content-start">
                                <li class="nav-item-staff d-none" role="presentation">
                                    <button @click="change_tab('my_objectives')"
                                            :class="current_tab === 'my_objectives' ? 'active' : ''" class="nav-link m-2"
                                            type="button" role="tab" aria-controls="pills-home"
                                            :aria-selected="current_tab === 'my_objectives' ? true : false">Objetivos</button>
                                </li>
                                <li class="nav-item-staff" role="presentation">
                                    <button @click="change_tab('my_challenges')"
                                            :class="current_tab === 'my_challenges' ? 'active' : ''" class="nav-link m-2"
                                            type="button" role="tab" aria-controls="pills-profile"
                                            :aria-selected="current_tab === 'my_challenges' ? true : false">Retos</button>
                                </li>
                                <li class="nav-item-staff" role="presentation">
                                    <button @click="change_tab('my_points')"
                                            :class="current_tab === 'my_points' ? 'active' : ''" class="nav-link m-2"
                                            type="button" role="tab" aria-controls="pills-profile"
                                            :aria-selected="current_tab === 'my_points' ? true : false">Puntos</button>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="col-12 col-md-6 d-flex justify-content-end order-2 order-md-3 d-none">
                        <div class="d-flex align-items-center ms-auto">
                            <!-- Filtro -->
                            <div class="d-flex align-items-center">
                                <span class="text-bat fs-6">Filtra por mes:</span>
                                <img class="ms-2" src="/img/icons/filter-points.svg" alt="filter-points">
                            </div>
                            <!-- Botón de guía -->
                            <div v-if="unit_guide.length !== 0" class="ms-3">
                                <button class="bg-transparent border-0 d-flex align-items-center" data-bs-toggle="modal" data-bs-target="#guiaDeUnidadesModal">
                                    <img :src="unit_guide.icon" alt="Guia de unidades" class="me-2">
                                    <span class="fs-6 text-indigo border-bottom text-title-bat">
                                        {{ unit_guide.title }}
                                    </span>
                                </button>
                            </div>
                        </div>
                    </div>

                    <div v-if="current_tab === 'my_challenges'" class="order-3 order-md-3">
                        <div>
                            <div class="mt-4">
                                <h6 class="text-bat">Estas son las actividades que ese usuario tiene disponibles, motívalo a participar.</h6>
                            </div>

                            <div v-if="activitiesPdv.length === 0" class="text-center mt-4">
                                <h6 class="text-bat">Este usuario no tiene retos activos.</h6>
                            </div>

                            <div v-else class="row justify-content-center p-3 py-5">
                                <div v-for="activity in activitiesPdv" :key="activity.id"
                                     class="col-lg-4 col-md-5 col-12 card-points my-3 my-sm-1">
                                    <div class="header">
                                        <div>
                                            <span class="badge" :class="{'tag-inactive-user': !client.active, 'tag-entregado': client.active}">Estado</span>
                                            <span class="traffic-light " :class="{'tag-inactive-user': !client.active, 'tag-entregado': client.active}"></span>
                                            Activo
                                        </div>
                                        <div class="box-staff" :class="{'box-points': client.active, 'box-points-negative': !client.active}">
                                            <span><strong>{{ activity.points_to_win }}<span> Puntos</span></strong></span>
                                        </div>
                                    </div>
                                    <div class="content">
                                        <div class="row">
                                            <div class="col-12">
                                                <h6>{{ formatName(activity.name) }}</h6>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-12 available-points">
                                                <h6>{{ getOptionText(activity.option) }}</h6>
                                            </div>
                                        </div>
                                        <div class="row date-history-points">
                                            <div class="col-12">
                                                <h6 class="text-bat"><strong>Vence: </strong>{{ formatDate(activity.expiration_date_end)}}</h6>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div v-if="current_tab === 'my_points'" class="order-3 order-md-3">
                        <div>
                            <div v-if="transactions.length === 0" class="text-center mt-4">
                                <h6 class="text-bat">Este usuario no tiene transacciones.</h6>
                            </div>

                            <div v-else class="row justify-content-center p-3 py-5">
                                <div v-for="transaction in transactions" :key="transaction.id" class="col-lg-4 col-md-5 col-12 card-points my-3 my-sm-1">
                                    <div class="header">
                                        <div>
                                            <h6>{{ transaction.transaction_type?.name }}</h6>
                                        </div>
                                        <div :class="{ 'box-points box-staff': !(transaction.transaction_type_id === 2 || transaction.transaction_type_id === 4 || transaction.transaction_type_id === 7), 'box-points-negative box-staff': transaction.transaction_type_id === 2 || transaction.transaction_type_id === 4 || transaction.transaction_type_id === 7 || !client.active }">
                                            <span><strong>{{ transaction.transaction_type_id === 2 || transaction.transaction_type_id === 4 || transaction.transaction_type_id === 7 ? '-' : '' }}
                                                {{ transaction.amount }}<span> Puntos</span></strong></span>
                                        </div>
                                    </div>
                                    <div class="content">
                                        <div class="row date-history-points">
                                            <div class="col-12 transaction_details mb-1">
                                                <h6>{{ transaction.transaction_detail }}</h6>
                                            </div>
                                            <div class="col-6">
                                                <p><strong>Fecha:</strong></p>
                                                <p><span>{{formatDate(transaction.created_at) }}</span></p>
                                            </div>
                                            <div class="col-6 pb-1" v-if="transaction.savings_expiration_date">
                                                <p><strong>Vence:</strong></p>
                                                <p><span>{{ formatDate(transaction.savings_expiration_date) }}</span>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Modal de inactivar usuario -->
                <el-dialog :visible.sync="modalInactivateUser" :width="getWidth()"
                           style="width: 75% !important; z-index: 2001; margin: 0 auto 50px !important;"
                           class="dialog-mobile" :close-on-click-modal="true" :close-on-press-escape="true"
                           :show-close="true">
                    <div class="row">
                        <div class="col-12">
                            <div class="d-flex flex-column align-items-center text-center">
                                <img src="/img-version2/icons/staff/user-remove.svg" alt="Icono" class="mb-2">
                                <h6 class="mx-auto" style="width: auto!important; max-width: 268px!important;">¿Seguro que deseas desvincular a <strong>{{ formatName(client.user.name) }}?</strong></h6>
                                <p class="text-bat px-0">Se reflejará próximamente y no se podrá cancelar el proceso.</p>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12" style="padding: 10px 0!important;">
                            <div class="d-flex flex-column align-items-center text-center">
                                <button @click="inactivateUser" class="mx-1 btn btnBlue text-title-bat rounded-3"
                                        type="button">
                                    Confirmar desvinculación
                                </button>
                            </div>
                        </div>
                        <div class="col-12" style="padding: 10px 0!important;">
                            <div class="d-flex flex-column align-items-center text-center">
                                <div class="text-more cursor-pointer buttonOne" type="buttoNot"
                                     @click="cancelInactivation">No, volver
                                </div>
                            </div>
                        </div>
                    </div>
                </el-dialog>

                <!-- Modal opciones de rechazado -->
                <el-dialog :visible.sync="modalRejected" width="400px" class="filterDialogCatalog">
                    <div class="modal-content">
                        <div class="row">
                            <div class="col-12">
                                <div class="d-flex flex-column align-items-center text-center">
                                    <img src="/img-version2/icons/staff/dangerstaff.svg" alt="Icono" class="mb-2">
                                    <h6 class="mx-auto" style="max-width: 268px;">¡Antes de desvincular, revisa esto!</h6>
                                    <p class="text-bat px-0">Puede que lo que quieras es transferir al usuario a otro punto de venta, ese proceso se hace por medio de transferencia.</p>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12" style="padding: 10px 0!important;">
                                <div class="d-flex flex-column align-items-center text-center">
                                    <button
                                        @click="showConfirmationAndHideRejected"
                                        :class="{'btn': true, 'rounded-3': true, 'bg-transparent': true, 'p-2': true, 'px-3': true, 'my-3': true, 'text-bat': true, 'align-items-center': true, 'btn-popups': true, 'text-indigo': true, 'fw-bold': true, 'd-block': true, 'd-md-inline-block': true, 'btn-staff': true}"
                                    >Continuar con desvinculación
                                    </button>
                                </div>
                            </div>
                            <div class="col-12" style="padding: 10px 0!important;">
                                <div class="d-flex flex-column align-items-center text-center">
                                    <div class="text-more cursor-pointer buttonOne" type="buttoNot"
                                         @click="modalRejected = false">Cancelar
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </el-dialog>
            </div>
        </div>
    </div>

</template>

<script>

export default {
    props: {
        client: Object,
        pdv: Object,
        client_segment: {
            default: null,
        },
        admin_staff: {
            default: [],
        }
    },
    data() {
        return {
            loading: 0,
            selected_moth: 0,
            selected_year: 0,
            show_slick: false,
            slickOptions: Object,
            available_client_months: [],
            unit_guide: [],
            status_display: false,
            progressWidth: 40,
            current_tab: 'my_challenges',
            modalInactivateUser: false,
            getWidth() {
                if (this.$mq === 'sm') {
                    return '95%';
                } else if (this.$mq === 'md') {
                    return '35%';
                } else if (this.$mq === 'lg') {
                    return '30%';
                } else {
                    return '20%';
                }
            },
            clientId: null,
            pdv_id: null,
            transactions: [],
            activitiesPdv: [],
            orderFilterPointsOption: null,
            modalRejected: false,
            rejectReasons: {
                4: "Baja voluntaria",
                5: "Cambio de rol",
                6: "Inactividad prolongada",
                7: "Incumplimiento de normas",
                8: "Duplicidad de cuenta",
                9: "Reemplazo por otro usuario"

            },
            percentage: 0,
            finishedActivities : 0,
            missingActivities : 0,
            totalActivities : 0,
            alert: false,
            check_save: false,
            requestsDisengagement: [],
            clientDisengagement:  false,
            isChampion: false,
            modalTransferUser: false,
            insituCodeTransfer: null,
        };
    },
    mounted() {
        if (this.month && this.year) {
            this.selected_moth = this.month;
            this.selected_year = this.year;
        }
        this.slickOptionsProps();
        this.getStatusDisplay();
        this.createProgressPoints();

        const pathname = window.location.pathname;

        const parts = pathname.split('/');

        if (parts.length > 2) {
            this.pdv_id = parts[parts.length - 2];
            this.clientId = parts[parts.length - 1];
        } else {
        }

        this.getTransactionsHistory();
        this.getActivitiesPdv();
        this.getRequestsForDisengagementPdv();
    },
    methods: {
        change_tab(tab) {
            this.current_tab = tab;
        },
        getStatusDisplay() {
            axios.get(`/status-display/${this.client_segment}`)
                .then(response => {
                    this.status_display = response.data.status_display;
                })
                .catch(e => {
                    //
                })
        },
        getMonthText(month) {
            switch (month) {
                case 1:
                    return "Enero";
                    break;
                case 2:
                    return "Febrero";
                    break;
                case 3:
                    return "Marzo";
                    break;
                case 4:
                    return "Abril";
                    break;
                case 5:
                    return "Mayo";
                    break;
                case 6:
                    return "Junio";
                    break;
                case 7:
                    return "Julio";
                    break;
                case 8:
                    return "Agosto";
                    break;
                case 9:
                    return "Septiembre";
                    break;
                case 10:
                    return "Octubre";
                    break;
                case 11:
                    return "Noviembre";
                    break;
                case 12:
                    return "Diciembre";
                    break;
                default:
                    break;
            }
        },
        slickOptionsProps() {
            this.slickOptions = {
                dots: true,
                arrows: false,
                infinite: true,
                centerMode: false,
                autoplay: false,
                slidesToShow: 3,
                slidesToScroll: 1,
                responsive: [
                    {
                        breakpoint: 1600,
                        settings: {
                            slidesToShow: 3,
                            slidesToScroll: 1,
                            infinite: true,
                            dots: true,
                        },
                    },
                    {
                        breakpoint: 1336,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 1,
                            infinite: true,
                            dots: true,
                        },
                    },
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                            infinite: true,
                            dots: true,
                        },
                    },
                    {
                        breakpoint: 480,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                        },
                    },
                ],
            };
        },
        customColorMethods(percentage, status) {
            if(status){
                if (percentage >= 100) {
                    return 'green';
                } else if (percentage >= 90 && percentage < 100) {
                    return 'orange';
                } else {
                    return 'red';
                }
            }else{
                return '#C1C1C1';
            }
        },
        formatUnitMeasure(text) {
            return text[0].toUpperCase() + text.substring(1).toLowerCase();
        },
        createProgressPoints() {
            const progressPoints = document.getElementsByClassName('progress-point');
            for (let i = 0; i < this.points; i++) {
                progressPoints[i].classList.add('progress-test');
            }
        },
        progressBarWidth() {
            return (this.progressPercentage / this.points) * 100;
        },
        getConditionalClass(objetive) {
            const advancePercentage = objetive;
            return {
                green: advancePercentage >= 100,
                yellow: advancePercentage >= 50 && advancePercentage < 100,
                red: advancePercentage < 50,
            };
        },
        getTransactionsHistory() {
            if (!this.clientId) {
                console.error("No se pudo obtener el clientId.");
                return;
            }
            this.loading = 1;

            axios.get(`/get-transactions-history/${this.clientId}`)
                .then(({ data }) => {
                    this.transactions = data.transactions;
                })
                .catch(error => {
                    console.error("Error al obtener los PDVs activos", error);
                })
                .finally(() => {
                    this.loading = 0;
                });
        },

        getActivitiesPdv() {
            if (!this.clientId) {
                console.error("No se pudo obtener el clientId.");
                return;
            }
            this.loading = 1;

            axios.get(`/get-client-pdv-activities/${this.clientId}`)
                .then(({ data }) => {
                    this.activitiesPdv = data.activities;
                    this.finishedActivities = data.finished_activities;
                    this.missingActivities = data.missing_activities;
                    this.totalActivities = data.total_activities;
                    this.percentage = data.percentage;
                })
                .catch(error => {
                    console.error("Error al obtener los PDVs activos", error);
                })
                .finally(() => {
                    this.loading = 0;
                });
        },

        inactivateUser() {
            axios.post(`/inactivate-client-staff/${this.selectedPdvId}`, {
                client_id: this.clientId.toString()
            })
                .then(response => {
                    if (response.status === 200 ) {
                        this.modalInactivateUser = false;
                        location.assign(`/get-pdv-details/${this.pdv.id}`);
                    }
                })
                .catch(error => {
                    console.error("Error al inactivar el usuario", error);
                });
        },

        cancelInactivation() {
            this.modalInactivateUser = false;
        },
        formatDate(dateString) {
            if (!dateString) {
                return '';
            }
            let formattedDateString = dateString.trim();

            if (formattedDateString.includes(' ')) {
                formattedDateString = formattedDateString.replace(' ', 'T');
            }

            const date = new Date(formattedDateString);

            const day = String(date.getDate()).padStart(2, '0');
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const year = date.getFullYear();

            return `${day}/${month}/${year}`;
        },

        getOptionText(option) {
            if (option === 'challenge') {
                return 'Reto';
            } else if (option === 'survey') {
                return 'Encuesta';
            } else if (option === 'learning') {
                return 'Aprendizaje';
            } else if (option === 'entertainment') {
                return 'Entretenimiento';
            } else {
                return option;
            }
        },
        formatName(name) {
            let nameParts = name.split(' ').map(part => {
                return part.charAt(0).toUpperCase() + part.slice(1).toLowerCase();
            });

            return nameParts.join(' ');
        },
        openRejectedModal() {
            this.modalRejected = true;
        },
        openInactivateModal(pdv_id) {
            this.selectedPdvId = pdv_id;
            this.modalRejected = true;
        },
        showConfirmationAndHideRejected(){
            this.modalRejected = false;
            this.modalInactivateUser = true;
        },
        getDotStyle(percentage) {
            const position = Math.min(Math.max(percentage, 0), 100) + '%';
            return {
                left: position,
                top: '50%',
                transform: 'translate(-50%, -50%)'
            };
        },
        format(percentage) {
            return percentage === 100 ? `${percentage}%` : `${percentage}%`;
        },
        getRequestsForDisengagementPdv() {
            if (!this.pdv.id) return;
            axios.get(`/get-requests-disengagement-pdv/${this.pdv.id}`)
                .then(({data}) => {
                  if (data.requestStaff && data.requestStaff.length > 0) {
                    this.requestsDisengagement = [...data.requestStaff];
                  } else {
                    this.requestsDisengagement = [];
                  }
                  this.validateRequestDisengagement();
                })
                .catch(error => {
                  console.error("Error al obtener las solicitudes de desvinculación del PDV", error);
                  this.requestsDisengagement = [];
                  this.validateRequestDisengagement();
                });

        },
        validateRequestDisengagement() {
            const matchedRequest = this.requestsDisengagement.find(
                req => req.identification_number === this.client.identification_number
            );
            if (matchedRequest) {
                this.clientDisengagement = true;
            }
        },
        transferUser(){
            window.location.href = `/transfer-user/send/${this.pdv.id}/${this.client.id}`;
        }
      },
};
</script>
